import React, { useEffect, useState, useRef } from 'react';
import styles from './detailsBox.module.scss';
import policeManIcon from '../../../assets/Imagess/policeMan.svg';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import ApplicantsTab from '../../Atoms/Tabs/InfoTab';
import emailIcon from '../../../assets/Imagess/GreenEmail.svg';
import phoneIcon from '../../../assets/Imagess/GreenPhone.svg';
import FormIcon from '../../../assets/Imagess/FormIcon.svg';
import InfoCard from '../../Atoms/Cards/InfoCard';
import PrintIcon from '../../../assets/Imagess/printIcon.svg';
import MoreButton from '../../Molecules/Custom/MoreButton';
import ReactToPrint from 'react-to-print';
import moment from 'moment';

function DetailsBox({ data, mode, setDetails, setMoveRight }) {
  const [info, setInfo] = useState(null);
  const [selected, setSelected] = useState('facilityForm');

  const componentRef = useRef(null);

  const tabs = [
    {
      index: 0,
      name: 'facilityForm',
      text: 'نموذج المنشأة',
      icon: FormIcon,
    },
  ];

  useEffect(() => {
    if (!data) {
      setInfo(null);
      return;
    }

    const coordinatorName = data.coordinatorName ?? data.name ?? '-';
    const phoneNumber = data.phoneNumber ?? data.mobile ?? '-';
    const email = data.email ?? '-';

    const createdOnDisplay = data.createdOn
      ? moment(data.createdOn).format('MMM Do YYYY, h:mm a')
      : '-';

    // facilityDates from your API looks like: "2025-12-16 18:43, 2025-12-17 18:43"
    const facilityDatesDisplay = data.eventDates ?? '-';

    const requestedHall = data.requestedHall ?? '-';
    // const organizationName = data.organizationName ?? '-';
    const description =
      data.description ?? data.eventOutcomes ?? data.eventGoal ?? '';

    const rawDates = Array.isArray(data.eventDates) ? data.eventDates : [];
    const sortedDates = [...rawDates].sort((a, b) => new Date(a) - new Date(b));

    // dates list (like: Dec 19, Dec 24...) BUT we’ll keep it as array so your UI list shows nicely
    const bookingDates = [
      ...new Set(sortedDates.map((d) => moment(d).format('MMM D'))),
    ];
    const bookingTime = sortedDates.length
      ? moment(sortedDates[0]).format('hh:mm A')
      : '-';

    const contactInfo = [
      {
        أسم_المنسق: coordinatorName,
        البريد_الإلكتروني: email,
        رقم_الهاتف: phoneNumber,
      },
    ];

    const eventInfo = [
      {
        عنوان_الحدث: data.eventTitle ?? '-',
        القاعة_المطلوبة: requestedHall,
        الجهة_المنظمة: data.organizingEntity ?? '-',
        الفئة_المستهدفة: data.targetAudience ?? '-',
        الهدف_من_الحدث: data.eventPurpose ?? '-',
      },
      {
        تاريخ: bookingDates.length ? bookingDates : '-',
        الوقت: bookingTime,
        عدد_الحضور: data.numberOfAttendees ?? '-',
        ملاحظات_أخرى: data.additionalNotes ?? '-',
      },
    ];
    setInfo({
      fullName: data.eventTitle ?? 'تفاصيل المرفق',
      email,
      phone: phoneNumber,
      program: [
        { title: 'اسم الحدث', text: data.eventTitle ?? '-' },
        { title: 'اسم المنسق', text: coordinatorName },
        { title: 'القاعة المطلوبة', text: requestedHall },
      ],
      description,
      contactInfo,
      eventInfo,
    });
  }, [data]);

  return (
    <>
      <div
        className={styles.parentContainer}
        id='PrintDetails'
        ref={componentRef}
      >
        <div className={styles['major-box']}>
          <div className={styles['box-side']}>
            <img src={policeManIcon} className={styles.leftImg} alt='icon' />
          </div>

          <div className={styles['box-body']}>
            <h3>{info?.fullName}</h3>

            {!!info?.email && info.email !== '-' && (
              <span className={styles.spanCont}>
                <img src={emailIcon} alt='email' />
                {info.email}
              </span>
            )}

            {!!info?.phone && info.phone !== '-' && (
              <span className={styles.spanCont}>
                <img src={phoneIcon} alt='phone' />
                {info.phone}
              </span>
            )}

            <hr />

            <div className={`${styles.row} ${styles.programs}`}>
              {info?.program?.map((i, index) => (
                <div key={index} className={styles['w-20']}>
                  <h4>{i.title}</h4>
                  <span>{i.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className={`${styles['tab-select-container']} ${styles.row}`}
          style={{ marginTop: '25px', marginBottom: '15px' }}
        >
          <div className={`${styles['tab-container']} ${styles['w-90']}`}>
            {tabs.map((tab) => (
              <ApplicantsTab
                key={tab.index}
                text={tab.text}
                icon={tab.icon}
                handleOnClick={() => setSelected(tab.name)}
                active={tab.name === selected}
                shadowed={false}
              />
            ))}
          </div>

          <div
            style={{ position: 'absolute', right: '40px', marginTop: '25px' }}
            className={styles['no-print']}
          >
            <MoreButton icon={moreInfo} top={1} right={30}>
              <div className={styles['in-container']}>
                <div>
                  <ReactToPrint
                    trigger={() => (
                      <div>
                        <img src={PrintIcon} alt='Details' />
                        <span>طباعة</span>
                      </div>
                    )}
                    content={() => componentRef.current}
                  />
                </div>
              </div>
            </MoreButton>
          </div>
        </div>

        <div className={styles.row}>
          <InfoCard
            title='تفاصيل الحدث'
            values={info?.eventInfo}
            width='w-49'
            column={2}
          />

          <InfoCard
            title='جهة الاتصال'
            values={info?.contactInfo}
            width='w-49'
          />

          {/* <InfoCard title='وصف الحدث' width='w-100' text={info?.description} /> */}
        </div>
      </div>
    </>
  );
}

export default DetailsBox;
